import React from 'react';

const Search = ({onSearch, onSearchChange, listedPartJSONString}) => {

	return (
		  <div className="br2 bn-ns br--top w-100 w-50-ns center pa2 pb1 ba b--black-10">
		    <fieldset className="cf bn ma0 pa0">
		      <div className="flex">
		        <label className="clip">Search Parts</label>
		        {/*<select className='match-type br0 b--moon-gray outline-0 f6 mb1 hover-brand-magenta'>
					<option value='or'>Any</option>
					<option value='and'>All</option>
		        </select>*/}
		        <div className='flex w-100'>
			        <input
			        	className="search-field input-reset ba1 fl black-80 bg-white pa2 lh-solid br2 br--left outline-0 f5-ns w-100 w-80"
			        	placeholder="Search for parts..."
			        	type="text"
			        	name="search-parts"
			        	onChange={(event) => onSearchChange(event, listedPartJSONString)}
			        	id="email-address"
			        	onKeyPress={(event) => onSearchChange(event, listedPartJSONString)}
					/>
			        <input
			        	className="f6 f5-l button-reset fl pv2 tc bn bg-animate bg-black-70 hover-bg-black white pointer br2 br--right h-100 w-20"
			        	type="submit"
			        	onClick={(event) => onSearch(event, listedPartJSONString)}
			        	value="Find"
			        />
		        </div>
		      </div>
		    </fieldset>
		  </div>	
		)
}

export default Search;